var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorpickerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    width: 30,
    height: 30,
    id: "color-picker",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00b76c",
    d: "m23 23.6-9.1-9.1C9 19.4 6 26.2 6 33.7h12.8c0-4 1.6-7.5 4.2-10.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00a05b",
    d: "M16.2 33.7h2.6c0-3.9 1.6-7.5 4.2-10l-1.2-1.2c-3.4 2.5-5.6 6.6-5.6 11.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#546f7a",
    d: "M18.8 33.7H6c0 7.5 3 14.2 7.9 19.1l9.1-9.1c-2.6-2.6-4.2-6.1-4.2-10z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#475d63",
    d: "M16.2 33.7c0 4.6 2.2 8.6 5.6 11.2l1.2-1.2c-2.6-2.6-4.2-6.1-4.2-10h-2.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#3d4ff9",
    d: "m23 43.7-9.1 9.1c4.9 4.9 11.6 7.9 19.1 7.9V47.8c-3.9 0-7.5-1.6-10-4.1z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#3046c1",
    d: "M30.3 47.7h.7c-3.1-.4-5.9-1.9-8-4l-1.2 1.2c2.4 1.7 5.3 2.8 8.5 2.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#39a4fa",
    d: "M33 47.8v12.8c7.5 0 14.2-3 19.1-7.9l-9.1-9c-2.5 2.5-6.1 4.1-10 4.1z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#0091e2",
    d: "M33 60.5v.1c7.5 0 14.2-3 19.1-7.9l-1.4-1.4C46.3 56.4 40 59.8 33 60.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#8b41f7",
    d: "M47.2 33.7c0 3.9-1.6 7.5-4.2 10l9.1 9.1C57 47.9 60 41.1 60 33.7H47.2z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#7539d3",
    d: "M57.3 33.7c0 6.8-2.5 12.9-6.6 17.7l1.4 1.4C57 47.9 60 41.1 60 33.7h-2.7z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff434d",
    d: "M47.2 33.7H60c0-7.5-3-14.2-7.9-19.1l-9.1 9c2.6 2.6 4.2 6.1 4.2 10.1z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#dd3646",
    d: "M57.3 33.7H60c0-7.5-3-14.2-7.9-19.1L50.7 16c4.1 4.7 6.6 10.9 6.6 17.7z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff6137",
    d: "m43 23.6 9.1-9.1C47.2 9.7 40.5 6.7 33 6.7v12.8c3.9 0 7.5 1.6 10 4.1z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#e04f32",
    d: "m50.7 16 1.4-1.4C47.2 9.7 40.5 6.7 33 6.7v.1c7 .7 13.3 4.1 17.7 9.2z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffd039",
    d: "M33 19.5V6.7c-7.5 0-14.2 3-19.1 7.9l9.1 9.1c2.5-2.6 6.1-4.2 10-4.2z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffae47",
    d: "M30.3 19.6c-3.2 0-6.1 1.1-8.5 2.8l1.2 1.2c2.1-2.1 4.9-3.6 8-4h-.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorpickerIcon);
export default __webpack_public_path__ + "static/media/colorpicker-icon.ac6d4e5d24102c9f28eae0b9ff83feaf.svg";
export { ForwardRef as ReactComponent };